import { render, staticRenderFns } from "./PlacementsStartComponentDevelopment.vue?vue&type=template&id=7ba1a125&scoped=true&"
import script from "./PlacementsStartComponentDevelopment.vue?vue&type=script&lang=js&"
export * from "./PlacementsStartComponentDevelopment.vue?vue&type=script&lang=js&"
import style0 from "./PlacementsStartComponentDevelopment.vue?vue&type=style&index=0&id=7ba1a125&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba1a125",
  null
  
)

export default component.exports